var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceCallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#C9F3E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0475 11.4471C18.6575 10.6676 17.8425 10.0371 16.8415 10.1486C15.946 10.2481 14.6165 10.5811 13.71 11.6731C12.7795 12.7946 12.4325 14.5436 13.147 17.1641C13.91 19.9596 15.043 22.7156 16.4515 24.9391C17.8495 27.1466 19.5715 28.9136 21.547 29.5911C23.294 30.1901 24.63 29.9401 25.6045 29.2821C26.5445 28.6476 27.0605 27.6931 27.3275 27.0321C27.6265 26.2921 27.4295 25.5216 27.0395 24.9536L25.601 22.8616C25.2832 22.3993 24.8257 22.051 24.2955 21.8677C23.7654 21.6844 23.1904 21.6758 22.655 21.8431L20.667 22.4646C20.6042 22.4861 20.5365 22.4887 20.4722 22.4721C20.408 22.4555 20.35 22.4203 20.3055 22.3711C19.4205 21.3346 18.429 19.8891 18.1595 18.4261C18.151 18.387 18.1568 18.3462 18.176 18.3111C18.4685 17.8196 18.9715 17.2626 19.4725 16.7751C20.321 15.9491 20.6425 14.6361 20.0825 13.5171L19.0475 11.4471Z",
    fill: "#00B680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceCallIcon);
export default __webpack_public_path__ + "static/media/VoiceCallIcon.83df971b7834f41bc264fafad1058c4e.svg";
export { ForwardRef as ReactComponent };